import React, { useCallback, useEffect, useMemo, useState } from "react";
import ECharts from "echarts-for-react";
const percentage = {
  فعالیت: {
    a: 0,
    b: 0.4,
    c: 0.6,
    d: 1,
  },
  استرس: {
    a: 0,
    b: 0.25,
    c: 0.75,
    d: 1,
  },
  ایستادن: {
    a: 0,
    b: 0.3,
    c: 0.7,
    d: 1,
  },
  خواب: {
    a: 0,
    b: 0.3,
    c: 0.7,
    d: 1,
  },
};

const EchartGaugespeedo2 = ({standsleep, stat, label }) => {

  const [options, setOptions] = useState({});

  useEffect(() => {
    setOptions({
      series: [
        {
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          center: ["50%", "75%"],
          radius: "90%",
          min: percentage[label].a*1000,
          max: 1000,
          splitNumber: 2,
          axisLine: {
            lineStyle: {
              width: 6,
              color: [
                [percentage[label]?.b, "#FF6E76"],
                [percentage[label]?.c, "#7CFFB2"],
                [percentage[label]?.d, "#FDDD60"],
              ],
            },
          },
          pointer: {
            icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
            length: "12%",
            width: 15,
            offsetCenter: [0, "-44%"],
            itemStyle: {
              color: "auto",
            },
          },
          axisTick: {
            length: 12,
            lineStyle: {
              color: "auto",
              width: 2,
            },
          },
          splitLine: {
            length: 8,
            lineStyle: {
              color: "auto",
              width: 2,
            },
          },
          axisLabel: {
            color: "#464646",
            fontSize: 11,
            distance: -33,
            rotate: "tangential",
            formatter: function (value) {
              if (value <= percentage[label]?.b * 1000) {
                return "نا مطلوب";
              } else if (value <= percentage[label]?.c * 1000) {
                return "طبیعی";
              } else if (value <= percentage[label]?.d * 1000) {
                return "بیش از حد";
              }
              return "";
            },
          },
          title: {
            offsetCenter: [0, "-0%"],
            fontSize: 13,
            fontWeight: "bold",
          },
          detail: {
            fontSize: 15,
            offsetCenter: [0, "-20%"],
            valueAnimation: true,
            formatter: function (value) {
              return (label==="ایستادن"?`${(standsleep.stand/(standsleep.sleep+standsleep.stand)).toFixed(1)*100}%`:
              label==="خواب"?`${(standsleep.sleep/(standsleep.sleep+standsleep.stand)).toFixed(1)*100}%`:value)
            },
            color: "black",
          },
          data: [
            {
              value: (label==="ایستادن"?(standsleep.stand/(standsleep.sleep+standsleep.stand)).toFixed(1)*1000:
              label==="خواب"?(standsleep.sleep/(standsleep.sleep+standsleep.stand)).toFixed(1)*1000:stat)

            },
          ],
        },
      ],
    });
  }, [stat]);

  return (
    <ECharts
      option={options}
      opts={{ renderer: "svg", width: "250px", height: "224px" }}
    />
  );
};
export default EchartGaugespeedo2;
